_collow.components.CourseIntro = class CourseIntro extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  courseName;
  allowedCourses;
  isUserLogged;

  constructor(root, elements, params) {
    super();
    this.root = root;
    this.elements = elements;
    this.params = params;
    this.isUserLogged = window.localStorage.getItem('token')

    this.courseName = params.course.toLowerDashed();
    this.generateTraningsLink();
    this.isUserLogged ? this.fetchAllowedCourses() : this.fetchFreeCourses()

    // Listen to logout and login state changes
    this.listen(document.body, "_collow.logout", this.handleLogout);
    this.listen(window, "_collow.current-user", this.handleUserChange);
    this.listen(document.body, "_collow.not-logged-in", this.handleLogout);
  }

  /** Handle user state changes from LoginChecker */
  handleUserChange = (event) => {
    const { currentUser } = event.detail;
    const wasLogged = this.isUserLogged;
    this.isUserLogged = !!currentUser;

    // If user just logged in, refetch courses
    if (!wasLogged && this.isUserLogged) {
      this.fetchAllowedCourses();
    }
    // If user just logged out, switch to guest mode
    else if (wasLogged && !this.isUserLogged) {
      this.handleLogout();
    }
  };

  /** Handle logout - switch to guest mode */
  handleLogout = () => {
    this.isUserLogged = false;
    this.setStartLayout();
    this.fetchFreeCourses();
  };

  /** listen to event if course already being followed. based on that render buttons start or continue */
  checkCourseFollowed = () => {
    const courses = localStorage.getCourses();

    let courseFollowed = false;
    courses.forEach((course) => {

      if (course.course["unique_identifer"] == this.courseName) {
        courseFollowed = true;
        let path = course?.["next_element"];
        if (!path) path = this.trainingLink;

        [
          this.elements.buttonContinue,
          this.elements.buttonContinueBottom,
        ].forEach((el) =>
          this.listen(el, "click", () => (window.location.pathname = path))
        );
      }
    });

    if (courseFollowed) {
      [
        this.elements.buttonContinueBottom,
        this.elements.buttonContinue,
      ].forEach((el) => {
        el.removeAttribute("hidden");
      });
      [this.elements.buttonStart, this.elements.buttonStartBottom].forEach(
        (el) => el.setAttribute("hidden", "")
      );
    } else {
      [this.elements.buttonStart, this.elements.buttonStartBottom].forEach((el) =>
        this.listen(el, "click", this.startCourse)
      );
    }
  };

  checkCourseStatus = (allowedCourses) => {
    const isAllowedCourse = allowedCourses.includes(this.courseName)

    if (isAllowedCourse) {
      this.checkCourseFollowed()
    } else {
      this.checkCourseToBuy()
    }

  }

  /** listen to event if course already being followed. based on that render buttons start or continue */
  checkCourseToBuy = () => {
    if (!this.allowedCourses.includes(this.courseName)) {
      const btnsCheckout = [this.elements.buttonCheckout, this.elements.buttonCheckoutBottom]
      const btnsContinueAndStart = [this.elements.buttonStart, this.elements.buttonStartBottom, this.elements.buttonContinue, this.elements.buttonContinueBottom]

      btnsCheckout.forEach((el) => {
        el.removeAttribute("hidden")
        this.listen(el, "click", () => (window.location.href = "/lifetime-access"))
      });
      btnsContinueAndStart.forEach((el) => el.setAttribute("hidden", ""));
      this.elements.hero.classList.add("grey-status")
    }
  };

  /** send coursestart to backend and redirects users if succesfully enrolled for course */
  startCourse = () => {
    const course = new FormData();
    course.append("course_ui", this.courseName);

    // check for the current user
    const token = window.localStorage.getItem("token");
    if (!token) {
      const url = new URL(`http://${this.params.host}/login`);
      url.searchParams.append(
        "course",
        `/course-introduction/${this.courseName}`
      );
      window.location = url;
    }
    fetch(this.params.path + "/course_registration", {
      method: "post",
      headers: {
        Authorization: token,
      },
      body: course,
    })
      .then(async (response) => {
        const res = await response.json();
        if (!response.ok) throw res;
        // get current local json
        const localJson = JSON.parse(
          window.localStorage.getItem("progressJson")
        );
        // append new started course
        localJson.course_registrations.unshift(res);
        const stringifyJson = JSON.stringify(localJson);
        window.localStorage.setItem("progressJson", stringifyJson);
        window.location.pathname = this.trainingLink;
      })
      .catch((err) => console.log(err));
  };

  generateTraningsLink = () => {
    this.trainingLink = `/course/${this.params.link
      .split("/")
      .map((str) => str.toLowerDashed())
      .join("/")}`;
  };

  setStartLayout = () => {
    [this.elements.buttonContinueBottom, this.elements.buttonContinue].forEach(
      (el) => el.setAttribute("hidden", "")
    );
    [this.elements.buttonStart, this.elements.buttonStartBottom].forEach((el) =>
      el.removeAttribute("hidden")
    );
  };

  /** Sets the course buttons for guest users (not logged in).
   * If the course is not free, hides the "Start" buttons and shows the "Checkout" buttons, redirecting the user to the login page on click.
   * If the course is free, hides the "Checkout" buttons and shows the "Start" buttons, also redirecting to the login page on click.
  */
  setCourseButtonsForGuest = (freeCourses) => {
    const btnsCheckout = [this.elements.buttonCheckout, this.elements.buttonCheckoutBottom]
    const btnsStart = [this.elements.buttonStart, this.elements.buttonStartBottom]

    btnsCheckout.forEach((el) => el.setAttribute("hidden", ""));
    btnsStart.forEach((el) => {
      el.removeAttribute("hidden")
      this.listen(el, "click", () =>
        _collow.Notify.error(this.params.loginToasterMessage, {
          actionLabel: this.params.loginPrompt,
          href: window.location.origin + '/login'
        }))
    });
  }

  /** Fetches allowed courses for current user/user group */
  fetchAllowedCourses = () => {
    let excludedProjects = ["Collow"];

    if (!excludedProjects.includes(this.params.project)) {
      this.checkCourseFollowed();
    } else {
      return fetching(this.params.path + "/course/allowed_courses")
        .then((res) => {
          this.allowedCourses = res.map(course => course.unique_identifer);
          this.checkCourseStatus(this.allowedCourses)
        })
    }
  }

  /** Fetches allowed courses for current user/user group */
  fetchFreeCourses = () => {
    return fetching(this.params.path + "/course")
      .then((res) => {
        const freeCourseCod = 116
        const freeCourses = res.filter(course => {
          if (course.exclusive_groups.includes(freeCourseCod)) {
            return course.unique_identifer
          }
        })
        const freeCoursesName = freeCourses.map(course => course.unique_identifer)
        this.setCourseButtonsForGuest(freeCoursesName)
      })
  }
};
